// extracted by mini-css-extract-plugin
module.exports = {"settings-block":"Sidebar_settings-block__LUiOY"};